import React from 'react';
import PropTypes from 'prop-types';

export default function HelpButton(props) {
  const { tooltipContent } = props;
  return (
    <span className="help-button">
      <i className="assignments-icon icon--question-mark" />
      <div className="help-button__tooltip">{tooltipContent}</div>
    </span>
  );
}

HelpButton.propTypes = {
  tooltipContent: PropTypes.node.isRequired,
};
